module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGc3dea7fc88fda826ff655d07545eb417.c3dea7fc.png";